module.exports = __webpack_public_path__ + "asana-2-55b5cd924e6e8f5e80a00934f7e63794.webp";